import { environment } from './../../../environments/environment';
import { KeycloakService } from "keycloak-angular";

export function initializeKeycloak (keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        url: environment.keycloack.url,
        realm: environment.keycloack.realm,
        clientId: environment.keycloack.clientId
      },
      initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri:
          globalThis.location.origin + '/assets/silent-check-sso.html'
      }
    });
}
